import React from "react";
import { useOverrides, Override } from "@quarkly/components";
import { Image, LinkBox, Box, Text, Link, Section } from "@quarkly/widgets";
const defaultProps = {
	"padding": "54px 0 30px 0",
	"quarkly-title": "Footer",
	"lg-padding": "30px 0 20px 0"
};
const overrides = {
	"box": {
		"kind": "Box",
		"props": {
			"empty-min-height": "64px",
			"empty-border-width": "1px",
			"empty-border-style": "solid",
			"width": "25%",
			"md-width": "50%",
			"sm-margin": "0px 0px 16px 0px",
			"empty-min-width": "64px",
			"empty-border-color": "LightGray",
			"padding": "16px 16px 16px 16px",
			"md-align-items": "flex-start",
			"md-display": "flex",
			"md-justify-content": "center",
			"sm-padding": "16px 16px 16px 0px"
		}
	},
	"linkBox": {
		"kind": "LinkBox",
		"props": {
			"href": "/index"
		}
	},
	"image": {
		"kind": "Image",
		"props": {
			"width": "248px",
			"height": "auto",
			"max-width": "100%",
			"src": "https://uploads.quarkly.io/67604c2fe5d27700189a24f0/images/Plant-Up.png?v=2024-12-16T16:23:23.563Z"
		}
	},
	"box1": {
		"kind": "Box",
		"props": {
			"width": "25%",
			"flex-direction": "column",
			"md-width": "50%",
			"sm-padding": "16px 16px 16px 0px",
			"empty-border-style": "solid",
			"empty-min-height": "64px",
			"empty-border-width": "1px",
			"empty-border-color": "LightGray",
			"padding": "16px 16px 16px 16px",
			"display": "flex",
			"empty-min-width": "64px"
		}
	},
	"text": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 32px 0px",
			"font": "--headline4",
			"color": "--dark",
			"lg-font": "600 24px/1.3 \"Manrope\", sans-serif",
			"children": "Navigation"
		}
	},
	"link": {
		"kind": "Link",
		"props": {
			"margin": "0px 0px 16px 0px",
			"lg-font": "normal 400 16px/1.5 \"Manrope\", sans-serif",
			"href": "/index",
			"text-decoration-line": "initial",
			"color": "--dark",
			"font": "--lead",
			"children": "Homepage"
		}
	},
	"link1": {
		"kind": "Link",
		"props": {
			"lg-font": "normal 400 16px/1.5 \"Manrope\", sans-serif",
			"text-decoration-line": "initial",
			"color": "--dark",
			"font": "--lead",
			"margin": "0px 0px 16px 0px",
			"href": "/faq",
			"children": "FAQ"
		}
	},
	"link2": {
		"kind": "Link",
		"props": {
			"color": "--dark",
			"font": "--lead",
			"margin": "0px 0px 16px 0px",
			"lg-font": "normal 400 16px/1.5 \"Manrope\", sans-serif",
			"text-decoration-line": "initial",
			"href": "/contacts",
			"children": "Contacts"
		}
	},
	"box2": {
		"kind": "Box",
		"props": {
			"empty-border-width": "1px",
			"padding": "16px 16px 16px 16px",
			"display": "flex",
			"md-width": "50%",
			"sm-padding": "16px 16px 16px 0px",
			"empty-min-width": "64px",
			"empty-min-height": "64px",
			"empty-border-style": "solid",
			"empty-border-color": "LightGray",
			"width": "25%",
			"flex-direction": "column"
		}
	},
	"text1": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 32px 0px",
			"font": "--headline4",
			"color": "--dark",
			"lg-font": "600 24px/1.3 \"Manrope\", sans-serif",
			"children": "Other"
		}
	},
	"link3": {
		"kind": "Link",
		"props": {
			"margin": "0px 0px 16px 0px",
			"lg-font": "normal 400 16px/1.5 \"Manrope\", sans-serif",
			"text-decoration-line": "initial",
			"color": "--dark",
			"font": "--lead",
			"href": "/privacy-policy",
			"children": "Privacy Policy"
		}
	},
	"box3": {
		"kind": "Box",
		"props": {
			"empty-min-height": "64px",
			"empty-border-width": "1px",
			"empty-border-color": "LightGray",
			"padding": "16px 16px 16px 16px",
			"display": "flex",
			"flex-direction": "column",
			"sm-padding": "16px 16px 16px 0px",
			"empty-min-width": "64px",
			"empty-border-style": "solid",
			"width": "25%",
			"md-width": "50%"
		}
	},
	"text2": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 32px 0px",
			"font": "--headline4",
			"color": "--dark",
			"lg-font": "600 24px/1.3 \"Manrope\", sans-serif",
			"children": "Contacts"
		}
	},
	"text3": {
		"kind": "Text",
		"props": {
			"margin": "0px 0px 32px 0px",
			"font": "--lead",
			"color": "--dark",
			"lg-font": "600 24px/1.3 \"Manrope\", sans-serif",
			"children": "+15195764240"
		}
	},
	"link4": {
		"kind": "Link",
		"props": {
			"margin": "0px 0px 16px 0px",
			"lg-font": "normal 400 16px/1.5 \"Manrope\", sans-serif",
			"text-decoration-line": "initial",
			"color": "--dark",
			"font": "--lead",
			"href": "info@greenbliss.com",
			"children": "info@greenbliss.com"
		}
	},
	"link5": {
		"kind": "Link",
		"props": {
			"lg-font": "normal 400 16px/1.5 \"Manrope\", sans-serif",
			"href": "#",
			"text-decoration-line": "initial",
			"color": "--dark",
			"font": "--lead",
			"margin": "0px 0px 16px 0px",
			"children": "256 King St E, Kitchener, ON N2G 2L1"
		}
	}
};

const Footer3 = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, defaultProps);
	return <Section {...rest}>
		<Override slot="SectionContent" flex-direction="row" md-flex-wrap="wrap" />
		<Box {...override("box")}>
			<LinkBox {...override("linkBox")}>
				<Image {...override("image")} />
			</LinkBox>
		</Box>
		<Box {...override("box1")}>
			<Text {...override("text")} />
			<Link {...override("link")} />
			<Link {...override("link1")} />
			<Link {...override("link2")} />
		</Box>
		<Box {...override("box2")}>
			<Text {...override("text1")} />
			<Link {...override("link3")} />
		</Box>
		<Box {...override("box3")}>
			<Text {...override("text2")} />
			<Text {...override("text3")} />
			<Link {...override("link4")} />
			<Link {...override("link5")} />
		</Box>
		{children}
	</Section>;
};

Object.assign(Footer3, { ...Section,
	defaultProps,
	overrides
});
export default Footer3;